export default __webpack_public_path__ + "static/media/screen6.8058587e.png";